import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { isPlatformBrowser } from '@angular/common';
import { FormCommonDataService } from '@form-field-module/common/services/form-common-data.service';
import { SEOService } from '@sb-tools/typescript/services/seo.service';
import { environment } from '@environment';

@Injectable({
    providedIn: 'root',
})
export class FormMetaResolverService {
    constructor(
        private formCommonDataService: FormCommonDataService,
        private seoService: SEOService,
        @Inject(PLATFORM_ID) private platformId: string,
    ) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<null | any> {
        if (isPlatformBrowser(this.platformId)) {
            return of(null);
        }
        this.formCommonDataService.community = route.params['community'] || '';
        this.formCommonDataService.formName = route.params['formName'] || '';
        const url = environment.formUrl + state.url.slice(1);

        return this.seoService.getFormSEOData(this.formCommonDataService.formName).pipe(
            tap((meta) => {
                this.seoService.setSEOData(meta, url);
            }),
            catchError(() => of(null)),
        );
    }
}
